// ========= START: src/components/AvatarDisplay.js (Complete File) =========
import React, { useState, useEffect, useRef } from 'react';

const getRandomVideo = (videoList) => {
  if (!videoList || videoList.length === 0) return null;
  return videoList[Math.floor(Math.random() * videoList.length)];
};

function AvatarDisplay({ botState, activeCharacter }) {
  const videoRef = useRef(null);
  const [videoSrc, setVideoSrc] = useState(getRandomVideo(activeCharacter.idleVideos));

 useEffect(() => {
    let newVideoSrc;
    if (botState === 'idle') {
      newVideoSrc = getRandomVideo(activeCharacter.idleVideos);
    } else { // 'talking'
      newVideoSrc = getRandomVideo(activeCharacter.talkingVideos);
    }
    setVideoSrc(newVideoSrc);
  }, [botState, activeCharacter]);

  const handleVideoEnded = () => {
    let nextVideoSrc;
    if (botState === 'idle') {
      nextVideoSrc = getRandomVideo(activeCharacter.idleVideos);
    } else {
      nextVideoSrc = getRandomVideo(activeCharacter.talkingVideos);
    }
    setVideoSrc(nextVideoSrc);
  };

  return (
    <div 
      className="avatar-container" 
      style={{ 
        backgroundImage: `url("${process.env.PUBLIC_URL}/assets/backgrounds/avatar-bp.jpeg")`, 
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        backgroundColor: 'transparent' 
      }}
    >
      {videoSrc && (
        <video
          ref={videoRef}
          key={videoSrc}
          className="avatar-video"
          src={videoSrc}
          autoPlay
          muted
          playsInline
          onEnded={handleVideoEnded}
        />
      )}
    </div>
  );
}

export default AvatarDisplay;
// ========= END: src/components/AvatarDisplay.js (Complete File) =========